export default __webpack_public_path__ + "static/image-cv_sp@2x-02b23e4c76f59d63849312a639a4e13c.png";